export const DASHBOARD_ACCESS = {
  map: { anyOf: ['tracking.position.view', 'system.organization.view_all'] },
  devices: {
    anyOf: ['fleet.vehicle.view', 'tracking.position.view', 'system.organization.view_all'],
  },
  deviceProfiles: {
    anyOf: ['fleet.device_profile.view', 'system.organization.view_all'],
  },
  fleetGroups: { anyOf: ['fleet.vehicle.view', 'system.organization.view_all'] },
  geofences: { anyOf: ['geofence.view', 'system.organization.view_all'] },
  alertRules: { anyOf: ['alert.rule.view', 'system.organization.view_all'] },
  routeReport: { anyOf: ['tracking.position.view', 'system.organization.view_all'] },
  members: { anyOf: ['member.view'] },
  organization: { anyOf: ['organization.view'] },
  roles: { anyOf: ['role.view'] },
  invitations: { anyOf: ['member.view'] },
  audit: { anyOf: ['audit.view', 'system.organization.view_all'] },
  systemAccess: { anyOf: ['system.user.view_all'] },
  systemUserManage: { allOf: ['system.user.view_all', 'system.user.manage'] },
  securitySettings: { anyOf: ['system.security.manage'] },
  geographyCodings: { anyOf: ['system.geography.manage'] },
};

export function hasPermissionAccess(permissions, access) {
  if (!access) return true;

  const permissionSet = permissions instanceof Set ? permissions : new Set(permissions || []);
  const matchesAny = !access.anyOf?.length || access.anyOf.some((code) => permissionSet.has(code));
  const matchesAll = !access.allOf?.length || access.allOf.every((code) => permissionSet.has(code));

  return matchesAny && matchesAll;
}

export function hasUserAccess(user, access) {
  return hasPermissionAccess(user?.activeContext?.permissions, access);
}

function filterNavigationItems(items, permissionSet) {
  return items.reduce((visibleItems, item) => {
    if (!hasPermissionAccess(permissionSet, item.access)) return visibleItems;

    if (item.children) {
      const children = filterNavigationItems(item.children, permissionSet);

      if (!children.length) return visibleItems;

      visibleItems.push({ ...item, path: children[0].path, children });
      return visibleItems;
    }

    visibleItems.push(item);
    return visibleItems;
  }, []);
}

export function filterNavigationData(data, permissions) {
  const permissionSet = new Set(permissions || []);

  return data.reduce((visibleGroups, group) => {
    const items = filterNavigationItems(group.items || [], permissionSet);

    if (items.length) visibleGroups.push({ ...group, items });

    return visibleGroups;
  }, []);
}
